import { render, staticRenderFns } from "./order-form-property-top-type.vue?vue&type=template&id=38efe025&scoped=true"
import script from "./order-form-property-top-type.vue?vue&type=script&lang=js"
export * from "./order-form-property-top-type.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-top-type.vue?vue&type=style&index=0&id=38efe025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38efe025",
  null
  
)

export default component.exports